import { makeStyles, Popover } from '@material-ui/core';
import { BigExclamationIcon } from 'app/assets/images/icons';
import { _t } from 'app/utils/i18n';
import React, { FunctionComponent, useRef, useState } from 'react';
import { useQuery } from 'react-query';
import Loader from '../Loader';

import MostFrequentCard from '../MostFrequentCard';

import styles from './RelatedItemsPop.module.scss';

interface Props {
  title: string;
  icon?: any;
  expandLink?: string;
  onItemClickAction?: any;
  slug?: any;
  topic_id?: number;
  item_id?: number;
}
const useStyles = makeStyles((theme) => ({
  popover: {
    pointerEvents: 'none',
  },
  popoverContent: {
    pointerEvents: 'auto',
  },
  paper: {
    padding: theme.spacing(0),
  },
}));
const RelatedItemsPop: FunctionComponent<Props> = ({
  title,
  icon,
  expandLink,
  onItemClickAction,
  slug,
  topic_id,
  item_id,
}) => {
  const classes = useStyles();
  const [openedPopover, setOpenedPopover] = useState(false);
  const [isEnabled, setIsEnabled] = useState(false);
  const popoverAnchor = useRef(null);

  const { isLoading, data } = useQuery<any>(
    ['getNewsKeywords', { item_id, topic_id }],
    slug,
    {
      enabled: isEnabled,
    }
  );

  const popoverEnter = () => {
    setOpenedPopover(true);
  };
  const iconPopoverEnter = async () => {
    setOpenedPopover(true);
    setIsEnabled(true);
  };
  const popoverLeave = () => {
    setOpenedPopover(false);
  };
  return (
    <div className={styles.RelatedItemsPop} data-testid="RelatedItemsPop">
      <i
        ref={popoverAnchor}
        aria-owns="mouse-over-popover"
        aria-haspopup="true"
        onMouseEnter={iconPopoverEnter}
        onMouseLeave={popoverLeave}
        className={styles.iconHolder}
      >
        {icon ? icon : <BigExclamationIcon />}
      </i>

      <div className="popper">
        <Popover
          id="mouse-over-popover"
          className={classes.popover}
          classes={{
            paper: classes.popoverContent,
          }}
          open={openedPopover}
          anchorEl={popoverAnchor.current}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          PaperProps={{
            onMouseEnter: popoverEnter,
            onMouseLeave: popoverLeave,
          }}
          disableRestoreFocus
        >
          <div className={styles.popper} data-testid="popper__holder">
            <div className={styles.title}>{title}</div>
            {isLoading && slug ? (
              <Loader />
            ) : (
              <MostFrequentCard
                words={icon ? data?.hashtags : data?.keywords}
                compId="related"
                hideDots
                withoutPadding
                expandLink={expandLink}
                onItemClickAction={onItemClickAction}
                noDataMsg={`${_t('basic:noFound')} ${title}`}
              />
            )}
          </div>
        </Popover>
      </div>
    </div>
  );
};

export default RelatedItemsPop;
